import React__default from 'react';
import { LineItemDeleteButton } from '@grandvisionhq/common';
import { useRemoveFromCart } from '../../../hooks/use-remove-from-cart.js';

const RemoveLineItemContainer = ({ lineItem  })=>{
    const [removeFromCart] = useRemoveFromCart(lineItem);
    const handleOnClick = React__default.useCallback(()=>{
        removeFromCart();
    }, [
        removeFromCart
    ]);
    return /*#__PURE__*/ React__default.createElement(LineItemDeleteButton, {
        onClick: handleOnClick
    });
};

export { RemoveLineItemContainer };
//# sourceMappingURL=RemoveLineItemContainer.js.map
